import { httpClient } from './httpClient';

const RESOURCE_PATH = 'api-common';

const commonService = {
  getSettings: function () {
    return httpClient.get(`${RESOURCE_PATH}/settings`);
  },
  submitSettings: function (data) {
    return httpClient.post(`${RESOURCE_PATH}/settings`, data);
  },
};

export default commonService;